import { useCallback } from 'react'

const useScrollToRef = () => {
  const scrollToRef = useCallback((ref, offset = 0) => {
    if (ref?.current) {
      const { current } = ref
      const top =
        current.getBoundingClientRect().top + window.pageYOffset + offset

      window.scrollTo({ top, behavior: 'smooth' })
    }
  }, [])

  return scrollToRef
}

export default useScrollToRef
